import React from 'react';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import Icon from '@spark/ui-components/components/Icon';
import Tooltip from '@spark/ui-components/components/Tooltip';
import { notification } from '@spark/ui-components/utils/notification';
import { formatarCNPJ, formatarDataSimples } from '@spark/utils/formatters';

const maskToken = (token) => {
  if (!token) return '-';
  if (token.length <= 10) return token;
  return `${token.slice(0, 6)}...${token.slice(-4)}`;
};

export const getDepositoClienteColumns = (onEdit, onRemove, loadingEditId, loadingRemoveId) => [
  {
    id: 'id',
    accessorKey: 'id',
    header: 'ID',
    size: 80,
    cell: ({ row }) => row.original.id ?? '-'
  },
  {
    id: 'nomeCliente',
    accessorKey: 'nomeCliente',
    header: 'Nome Cliente',
    size: 220,
    cell: ({ row }) => row.original.nomeCliente || '-'
  },
  {
    id: 'cnpjCliente',
    accessorKey: 'cnpjCliente',
    header: 'CNPJ',
    size: 160,
    cell: ({ row }) => formatarCNPJ(row.original.cnpjCliente || '')
  },
  {
    id: 'diasRecorrencia',
    accessorKey: 'diasRecorrencia',
    header: 'Dias Recorrencia',
    size: 130,
    cell: ({ row }) => row.original.diasRecorrencia ?? '-'
  },
  {
    id: 'diaEmissaoInicial',
    accessorKey: 'diaEmissaoInicial',
    header: 'Dia Emissao Inicial',
    size: 160,
    cell: ({ row }) => row.original.diaEmissaoInicial ?? '-'
  },
  {
    id: 'diaEmissaoFinal',
    accessorKey: 'diaEmissaoFinal',
    header: 'Dia Emissao Final',
    size: 160,
    cell: ({ row }) => row.original.diaEmissaoFinal ?? '-'
  },
  {
    id: 'tokenRastreamento',
    accessorKey: 'tokenRastreamento',
    header: 'Token Rastreamento',
    size: 220,
    cell: ({ row }) => {
      const token = row.original.tokenRastreamento;
      if (!token) return '-';

      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span>{maskToken(token)}</span>
          <Tooltip dir="top" text="Copiar token">
            <span className="d-inline-block">
              <ButtonWithLoading
                variant="outline-secondary"
                size="sm"
                onClick={async (event) => {
                  event.stopPropagation();
                  try {
                    await navigator.clipboard.writeText(token);
                    notification.success('Token copiado!');
                  } catch (error) {
                    notification.error('Nao foi possivel copiar o token.');
                  }
                }}
              >
                Copiar
              </ButtonWithLoading>
            </span>
          </Tooltip>
        </div>
      );
    }
  },
  {
    id: 'tokenRastreamentoAtivo',
    accessorKey: 'tokenRastreamentoAtivo',
    header: 'Token Ativo',
    size: 120,
    cell: ({ row }) => (row.original.tokenRastreamentoAtivo === true ? 'Sim' : 'Nao')
  },
  {
    id: 'nomeResponsavelComercial',
    accessorKey: 'nomeResponsavelComercial',
    header: 'Resp. Comercial',
    size: 200,
    cell: ({ row }) => row.original.nomeResponsavelComercial || '-'
  },
  {
    id: 'nomeResponsavelLancamento',
    accessorKey: 'nomeResponsavelLancamento',
    header: 'Resp. Lancamento',
    size: 200,
    cell: ({ row }) => row.original.nomeResponsavelLancamento || '-'
  },
  {
    id: 'nomeResponsavelFechamento',
    accessorKey: 'nomeResponsavelFechamento',
    header: 'Resp. Fechamento',
    size: 200,
    cell: ({ row }) => row.original.nomeResponsavelFechamento || '-'
  },
  {
    id: 'dataCriacao',
    accessorKey: 'dataCriacao',
    header: 'Data Criacao',
    size: 130,
    cell: ({ row }) =>
      row.original.dataCriacao ? formatarDataSimples(row.original.dataCriacao) : '-'
  },
  {
    id: 'dataAtualizacao',
    accessorKey: 'dataAtualizacao',
    header: 'Data Atualizacao',
    size: 130,
    cell: ({ row }) =>
      row.original.dataAtualizacao ? formatarDataSimples(row.original.dataAtualizacao) : '-'
  },
  {
    id: 'acoes',
    header: 'Acoes',
    size: 160,
    cell: ({ row }) => (
      <div style={{ display: 'flex', gap: 8 }}>
        <Tooltip dir="top" text="Editar">
          <span className="d-inline-block">
            <ButtonWithLoading
              variant="primary"
              size="sm"
              loading={loadingEditId === row.original.id}
              disabled={loadingEditId === row.original.id}
              onClick={(event) => {
                event.stopPropagation();
                onEdit(row.original.id);
              }}
            >
              <Icon name="pencil" size={16} />
            </ButtonWithLoading>
          </span>
        </Tooltip>
        <Tooltip dir="top" text="Remover">
          <span className="d-inline-block">
            <ButtonWithLoading
              variant="outline-danger"
              size="sm"
              loading={loadingRemoveId === row.original.id}
              disabled={loadingRemoveId === row.original.id}
              onClick={(event) => {
                event.stopPropagation();
                onRemove(row.original.id);
              }}
            >
              <Icon name="trash" size={16} />
            </ButtonWithLoading>
          </span>
        </Tooltip>
      </div>
    ),
    enableSorting: false
  }
];
